export const utilsType = {
    SET_DOCUMENTS_TYPE: 'SET_DOCUMENTS_TYPE',
    SET_CIVIL_STATUSES: 'SET_CIVIL_STATUSES',
    SET_DEPARTMENTS: 'SET_DEPARTMENTS',
    SET_PROVINCES: 'SET_PROVINCES',
    SET_DISTRICTS: 'SET_DISTRICTS',
    SET_ACADEMIC_LEVELS: 'SET_ACADEMIC_LEVELS',
    SET_SPECIALTIES: 'SET_SPECIALTIES',
    SET_GENDER: 'SET_GENDER',
    SET_PROVIDERS: 'SET_PROVIDERS',
    SET_JOB_LEVELS: 'SET_JOB_LEVELS',
    SET_JOB_ROLES: 'SET_JOB_ROLES',
    SET_AREAS: 'SET_AREAS',
    SET_ITEMS: 'SET_ITEMS',
    SET_WITHDRAWAL_REASONS: 'SET_WITHDRAWAL_REASONS',
    SET_ACCOUNT: 'SET_ACCOUNT',
    SET_ERROR: 'SET_ERROR',
    SET_PERIODS: 'SET_PERIODS',
    SET_RUBROS_OP: 'SET_RUBROS_OP',
    SET_DISTRICTS_LIMA: 'SET_DISTRICTS_LIMA',
    SET_DISTRICTS_BY_TEXT: 'SET_DISTRICTS_BY_TEXT',
    SET_INSTITUTES: 'UTILS/SET_INSTITUTES',
    SET_ONGS: 'UTILS/SET_ONGS',
    SET_UNIVERSITIES: 'UTILS/SET_UNIVERSITIES',
    SET_PLANS : 'UTILS/SET_PLANS'
};
